export const THEME_PICKER_STATE_PARAMETER = 'openThemePicker';
